var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2217 8.82372L15.0217 16.0237C14.7877 16.2577 14.4073 16.2577 14.1733 16.0237C13.9393 15.7897 13.9393 15.4093 14.1733 15.1753L20.3485 9.00012L0.79694 9.00012C0.465741 9.00012 0.19694 8.73132 0.19694 8.40012C0.19694 8.06892 0.465741 7.80012 0.796941 7.80012L20.3485 7.80012L14.1733 1.62492C13.9393 1.39092 13.9393 1.01052 14.1733 0.776521C14.2909 0.65892 14.4445 0.601321 14.5981 0.601321C14.7517 0.601321 14.9053 0.660121 15.0229 0.776521L22.2229 7.97652C22.4569 8.21052 22.4569 8.59092 22.2229 8.82492L22.2217 8.82372Z",
    fill: "#1B2646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0d26df595b3412535628e30fa449a04b.svg";
export { ForwardRef as ReactComponent };